import { I18nContext } from "components/I18N";
import { useContext } from "react";
import dayjs from "dayjs";

const DateNameDisplay = ({
  light = false,
  center = false,
  title,
  authorName,
  reviewedBy,
  createdAt,
}) => {

  function removeHtmlTags(htmlString) {
    if(htmlString){
      return htmlString.replace(/<[^>]*>/g, '');
    }
    return
  }


  const { I18n, langCode } = useContext(I18nContext);
  I18n.setLanguage(langCode);

  const _personIcon = light ? "/icons/person-white.svg" : "/icons/person.svg";
  const _calendarIcon = light
    ? "/icons/calendar-white.svg"
    : "/icons/calendar.svg";
  const _containerClassName = `flex flex-col ${center ? "gap-0" : "gap-1"} ${
    light && "text-white"
  }`;
  const _itemClassName = `flex items-center ${center && "justify-center"}`;

  return (
    <div className={_containerClassName}>
      <div>
        <h3
          className="feat-blog-title font-bold my-2 md:my-4"
          // style={{ fontSize: "18px!important" }}
          dangerouslySetInnerHTML={{
            __html: removeHtmlTags(title),
          }}
        />
      </div>
      <div className={_itemClassName}>
        <img src={_personIcon} alt={`blog author ${authorName}`} />
        <p className="small2 ml-2">
          {`${authorName} | ${I18n.get("reviewedBy").replace(
            "{{name}}",
            reviewedBy
          )}`}
        </p>
      </div>
      <div className={_itemClassName}>
        <img src={_calendarIcon} alt={`blog calendar`} />
        <p className="small2 ml-2">{dayjs(createdAt).format("DD/MM/YYYY")}</p>
      </div>
    </div>
  );
};

export default DateNameDisplay;
